module.exports = __webpack_public_path__ + "static/media/LockIcon.1da8a78d.svg";